"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = require("../../helpers/colors");
var _tokens = require("../../tokens");
var _ButtonBase = _interopRequireDefault(require("./ButtonBase"));
var _constants = require("./constants");
var _styles = require("./styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const StyledNakedButton = (0, _styledComponents.default)(_ButtonBase.default).withConfig({
  displayName: "StyledNakedButton",
  componentId: "sc-arfcr7-0"
})(["position:relative;border:0;background:transparent;&:after{content:'';position:absolute;top:-", ";bottom:-", ";left:-", ";right:-", ";}&:disabled{color:unset;background:unset;}"], _tokens.GTR.XS, _tokens.GTR.XS, _tokens.GTR.XS, _tokens.GTR.XS);
const NakedButton = props => /*#__PURE__*/_react.default.createElement(StyledNakedButton, props);
NakedButton.defaultProps = _ButtonBase.default.defaultProps;
const StyledPlainButton = (0, _styledComponents.default)(_ButtonBase.default).withConfig({
  displayName: "StyledPlainButton",
  componentId: "sc-arfcr7-1"
})(["position:relative;border:0;background:transparent;color:", ";", " &:active{color:", ";}&:disabled{color:", ";background:unset;}"], _tokens.COLOR.GREY.DARK, _ref => {
  let {
    size,
    flush
  } = _ref;
  const sizeSettings = _constants.SIZE[size];
  const verticalPadding = sizeSettings.padding[0] - _constants.BORDER_WIDTH;
  const horizontalPadding = sizeSettings.padding[1] - _constants.BORDER_WIDTH;

  /**
   * These css custom properties can be set in any parent to control the negative margin around plain buttons
   * The negative margin allows us to align these buttons as if they don't have any padding
   * but when used in a block-level layout (such as in ButtonGroup) we may need to remove them
   */
  return `
    font-size: ${_constants.SIZE[size].fontSize};
    padding: ${verticalPadding}px ${horizontalPadding}px;

    ${flush ? `
      margin: -${verticalPadding}px -${horizontalPadding}px;
    ` : ''}
    margin:
      calc(var(--plain-button-flush-vertical-boolean, ${flush ? 1 : 0}) * -${verticalPadding}px)
      calc(var(--plain-button-flush-horizontal-boolean, ${flush ? 1 : 0}) * -${horizontalPadding}px);
  `;
}, _tokens.COLOR.BLACK, _tokens.COLOR.GREY.MEDIUM);
const PlainButton = props => /*#__PURE__*/_react.default.createElement(StyledPlainButton, props);
PlainButton.defaultProps = _ButtonBase.default.defaultProps;
const StyledUnderlineButton = (0, _styledComponents.default)(PlainButton).withConfig({
  displayName: "StyledUnderlineButton",
  componentId: "sc-arfcr7-2"
})(["text-decoration:underline;"]);
const UnderlineButton = props => /*#__PURE__*/_react.default.createElement(StyledUnderlineButton, props);
UnderlineButton.defaultProps = _ButtonBase.default.defaultProps;
const StyledPrimaryButton = (0, _styledComponents.default)(_ButtonBase.default).withConfig({
  displayName: "StyledPrimaryButton",
  componentId: "sc-arfcr7-3"
})(["", " color:", ";background-color:", ";", " &:hover{background-color:", ";}&:active{background-color:", ";}"], _styles.solidButtonStyles, _tokens.COLOR.BLACK, _tokens.COLOR.ACCENT.PRIMARY, (0, _styles.loadingStyles)(_tokens.COLOR.ACCENT.PRIMARY, _tokens.COLOR.ACCENT.PRIMARY_60), _tokens.COLOR.ACCENT.PRIMARY_60, _tokens.COLOR.ACCENT.PRIMARY_120);
const PrimaryButton = props => /*#__PURE__*/_react.default.createElement(StyledPrimaryButton, props);
PrimaryButton.defaultProps = _ButtonBase.default.defaultProps;
const StyledSecondaryButton = (0, _styledComponents.default)(_ButtonBase.default).withConfig({
  displayName: "StyledSecondaryButton",
  componentId: "sc-arfcr7-4"
})(["", " color:", ";background-color:", ";", " &:hover{background-color:", ";}&:active{background-color:", ";}"], _styles.solidButtonStyles, _tokens.COLOR.WHITE, _tokens.COLOR.ACCENT.SECONDARY, (0, _styles.loadingStyles)(_tokens.COLOR.ACCENT.SECONDARY_120, _tokens.COLOR.ACCENT.SECONDARY), (0, _colors.shade)(_tokens.COLOR.ACCENT.SECONDARY, 80), _tokens.COLOR.ACCENT.SECONDARY_120);
const SecondaryButton = props => /*#__PURE__*/_react.default.createElement(StyledSecondaryButton, props);
SecondaryButton.defaultProps = _ButtonBase.default.defaultProps;
const StyledWhiteButton = (0, _styledComponents.default)(_ButtonBase.default).withConfig({
  displayName: "StyledWhiteButton",
  componentId: "sc-arfcr7-5"
})(["", " color:", ";background-color:", ";", " &:hover{background-color:", ";}&:active{background-color:", ";}"], _styles.solidButtonStyles, _tokens.COLOR.BLACK, _tokens.COLOR.WHITE, (0, _styles.loadingStyles)(_tokens.COLOR.WHITE, (0, _colors.alpha)(_tokens.COLOR.WHITE, 0.6)), (0, _colors.alpha)(_tokens.COLOR.WHITE, 0.8), (0, _colors.alpha)(_tokens.COLOR.WHITE, 0.6));
const WhiteButton = props => /*#__PURE__*/_react.default.createElement(StyledWhiteButton, props);
WhiteButton.defaultProps = _ButtonBase.default.defaultProps;
const StyledBorderedButton = (0, _styledComponents.default)(_ButtonBase.default).withConfig({
  displayName: "StyledBorderedButton",
  componentId: "sc-arfcr7-6"
})(["", ";color:", ";border-color:", ";", " &:hover{background-color:", ";}&:active{background-color:", ";}"], _styles.outlineButtonStyles, _tokens.COLOR.BLACK, _tokens.COLOR.GREY.LIGHT, (0, _styles.loadingStyles)((0, _colors.alpha)(_tokens.COLOR.GREY.LIGHT, 0.4), 'transparent'), (0, _colors.alpha)(_tokens.COLOR.GREY.LIGHT, 0.2), (0, _colors.alpha)(_tokens.COLOR.GREY.LIGHT, 0.4));
const BorderedButton = props => /*#__PURE__*/_react.default.createElement(StyledBorderedButton, props);
BorderedButton.defaultProps = _ButtonBase.default.defaultProps;
const StyledBorderedDarkButton = (0, _styledComponents.default)(_ButtonBase.default).withConfig({
  displayName: "StyledBorderedDarkButton",
  componentId: "sc-arfcr7-7"
})(["", ";color:", ";border-color:", ";", " &:hover{background-color:", ";}&:active{background-color:", ";}"], _styles.outlineButtonStyles, _tokens.COLOR.BLACK, _tokens.COLOR.GREY.DARK, (0, _styles.loadingStyles)((0, _colors.alpha)(_tokens.COLOR.GREY.LIGHT, 0.4), 'transparent'), (0, _colors.alpha)(_tokens.COLOR.GREY.LIGHT, 0.2), (0, _colors.alpha)(_tokens.COLOR.GREY.LIGHT, 0.4));
const BorderedDarkButton = props => /*#__PURE__*/_react.default.createElement(StyledBorderedDarkButton, props);
BorderedDarkButton.defaultProps = _ButtonBase.default.defaultProps;
const StyledDangerButton = (0, _styledComponents.default)(_ButtonBase.default).withConfig({
  displayName: "StyledDangerButton",
  componentId: "sc-arfcr7-8"
})(["", ";color:", ";border-color:", ";", " &:hover{background-color:", ";color:", ";}&:active{background-color:", ";border-color:", ";color:", ";}"], _styles.outlineButtonStyles, _tokens.COLOR.STATE.ERROR, _tokens.COLOR.STATE.ERROR, (0, _styles.loadingStyles)((0, _colors.alpha)(_tokens.COLOR.STATE.ERROR, 0.1), 'transparent'), _tokens.COLOR.STATE.ERROR, _tokens.COLOR.WHITE, _tokens.COLOR.STATE.ERROR_120, _tokens.COLOR.STATE.ERROR_120, _tokens.COLOR.WHITE);
const DangerButton = props => /*#__PURE__*/_react.default.createElement(StyledDangerButton, props);
DangerButton.defaultProps = _ButtonBase.default.defaultProps;
const ButtonComponent = NakedButton;
ButtonComponent.Plain = PlainButton;
ButtonComponent.Underline = UnderlineButton;
ButtonComponent.Primary = PrimaryButton;
ButtonComponent.Secondary = SecondaryButton;
ButtonComponent.White = WhiteButton;
ButtonComponent.Bordered = BorderedButton;
ButtonComponent.BorderedDark = BorderedDarkButton;
ButtonComponent.Danger = DangerButton;
var _default = exports.default = ButtonComponent;